import { Select } from '@rivallapp/native-base';

// TODO: refactor with flex={1} property
// throws error in all web uses about `onHoverIn` and `onHoverOut` props
// requires additional research because customizing loses <Select.Item>

export default Select;
